import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

/**
 * CompetencyRadar displays competency profile data.
 * Uses a simplified bar chart representation rather than requiring
 * a charting library dependency. Can be replaced with Recharts RadarChart later.
 *
 * Props:
 *   data: Array<{ dimension: string, score: number, maxScore: number }>
 *   size: 'compact' | 'full'
 */
const CompetencyRadar = ({ data = [], size = 'compact' }) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Complete sessions to see your competency profile
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ py: size === 'compact' ? 1 : 2 }}>
      {data.map((item) => {
        const percentage = item.maxScore > 0 ? (item.score / item.maxScore) * 100 : 0;
        const getColor = (pct) => {
          if (pct >= 75) return 'success';
          if (pct >= 50) return 'warning';
          return 'error';
        };

        return (
          <Box key={item.dimension} sx={{ mb: size === 'compact' ? 1 : 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
              <Typography variant={size === 'compact' ? 'caption' : 'body2'} fontWeight={500}>
                {item.dimension}
              </Typography>
              <Typography variant={size === 'compact' ? 'caption' : 'body2'} color="text.secondary">
                {Math.round(percentage)}%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={percentage}
              color={getColor(percentage)}
              sx={{ height: size === 'compact' ? 4 : 6, borderRadius: 3 }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default CompetencyRadar;
